import { Formik } from 'formik';
import { ReactFormGenerator, TaskData } from 'react-form-builder';
import { ModalContentWrapper } from 'ui';
import { RegisterResponse } from 'compliance-api';

interface FormPreviewModalProps {
  title: string;
  taskData: TaskData[];
  registers: RegisterResponse[];
  open: boolean;
  onClose: () => void;
}

const FormPreviewModal = ({ title, registers, taskData, open, onClose }: FormPreviewModalProps) => {
  return (
    <ModalContentWrapper
      title={title}
      open={open}
      onClose={onClose}
      classes={{ dialogPanel: '!max-w-[720px]' }}
      showPrint={true}
    >
      <div
        id={'print-area'}
        className="w-full flex flex-col print:bg-white print:text-black print:p-10"
      >
        <style>
          {`
          .react-form-builder-form {
            aspect-ratio: 1 / 1.414;
            overflow: auto;
            padding: 0 5px;
          }
          `}
        </style>
        {/*Dummy formik so InlineComponent logic works*/}
        <Formik
          initialValues={{ data: taskData }}
          onSubmit={() => {
            console.log('Submitted');
          }}
        >
          <ReactFormGenerator
            registers={registers}
            items={taskData}
            readOnly
            collapseThreeColumnFileUploadLayout
          />
        </Formik>
      </div>
    </ModalContentWrapper>
  );
};

export default FormPreviewModal;
